import { createConfig, http } from 'wagmi';
import { mainnet, polygon, arbitrum, base, optimism } from 'wagmi/chains';
import { injected, walletConnect } from 'wagmi/connectors';

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';

// Only add WalletConnect if project ID is available
const connectors = projectId 
  ? [
      injected(),
      walletConnect({ projectId }),
    ]
  : [injected()];

export const wagmiConfig = createConfig({
  chains: [mainnet, polygon, arbitrum, base, optimism],
  connectors,
  transports: {
    [mainnet.id]: http('https://eth.llamarpc.com'),
    [polygon.id]: http('https://polygon.llamarpc.com'),
    [arbitrum.id]: http('https://arb1.arbitrum.io/rpc'),
    [base.id]: http('https://mainnet.base.org'),
    [optimism.id]: http('https://mainnet.optimism.io'),
  },
});

export const supportedChains = [
  { id: 1, name: 'Ethereum', symbol: 'ETH', icon: '⟠' },
  { id: 137, name: 'Polygon', symbol: 'MATIC', icon: '⬡' },
  { id: 42161, name: 'Arbitrum', symbol: 'ETH', icon: '🔵' },
  { id: 8453, name: 'Base', symbol: 'ETH', icon: '🔷' },
  { id: 10, name: 'Optimism', symbol: 'ETH', icon: '🔴' },
];

export const popularTokens = [
  { symbol: 'ETH', name: 'Ethereum', icon: '⟠' },
  { symbol: 'USDC', name: 'USD Coin', icon: '💵' },
  { symbol: 'USDT', name: 'Tether', icon: '💲' },
  { symbol: 'WBTC', name: 'Wrapped Bitcoin', icon: '₿' },
  { symbol: 'DAI', name: 'Dai', icon: '◈' },
];
